import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import App from './App.vue';
import { router } from './router';
import store from './store';

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  console.log(router.app.$store);
  if (to.matched.some(record => record.meta.requiresAuth) && !window.localStorage.getItem('token')) {
    window.console.log('Not authenticated');
    return next('/login');
  }
  return next();
});
sync(store, router);

// Check local storage to handle refreshes
if (window.localStorage) {
  store.dispatch('login/a_init_token', window.localStorage.getItem('token'));
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
